export default __webpack_public_path__ + "static/media/Gmail-logo.e4ff4a7e.jpg";